export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/order_pending.415b3058.svg","height":24,"width":23,"blurWidth":0,"blurHeight":0};